import { isCanvasTheme } from 'foundations-theming/utils';
import styled from 'styled-components';
export const SIGNUP_LINK_COLOR = '#0b8484';
export const StyledUILink = styled.span.withConfig({
  displayName: "TextInputstyles__StyledUILink",
  componentId: "sc-1hrfhl6-0"
})(["", ";"], props => isCanvasTheme(props.theme) && `
      color: ${SIGNUP_LINK_COLOR} !important;

      & svg {
        fill: ${SIGNUP_LINK_COLOR} !important;
      }
    `);